import PropTypes from 'prop-types';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tooltip, Box, Typography, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useSelector } from '../../redux/store';
import Iconify from '../iconify';
import { CatalogItem } from '../../pages/dashboard';
import { useScopeCheck } from '../scopes';
import { addHyperlink } from '../../utils/formatText';
import CloseIconButton from '../basic-buttons/CloseIconButton';

ProductItem.propTypes = {
  row: PropTypes.object,
  disabled: PropTypes.bool
};

export default function ProductItem({ row, disabled = false }) {
  const { id = '' } = useParams();
  const hasAccess = useScopeCheck(['Edit-Order'], true);
  const { orderById } = useSelector((state) => state.orders || {});
  const { unsavedChanges } = orderById[id] || {};

  const [open, setOpen] = useState(false);

  const handleClickOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        disableHoverListener={disabled}
        title={
          row.notes || unsavedChanges ? (
            <>
              {unsavedChanges && <div>You must save changes before editing a item </div>}
              {unsavedChanges && row.notes && <br />}

              <Typography sx={{ whiteSpace: "pre-line", fontSize: '12px' }}>
                Notes:  {addHyperlink(row.notes)}
              </Typography> 
            </>
          ) : null
        }
      >
        {hasAccess && row.itemId > 0 ? (
          <Box
            sx={{
              display: 'flex', // Use flexbox
              alignItems: 'flex-bottom', // Vertically align items to center
              '&:hover': {
                cursor: disabled ? 'default' :'pointer',
              },
            }}
            onClick={() => unsavedChanges || disabled ? null : handleClickOpen(row.productId)}
          >
            <Typography
              variant="subtitle2"
              // color="secondary"
              component="span" // Use span here to prevent nested paragraphs
              sx={{
                textDecoration: 'underline',
              }}
            >
              PS{row.productId}
            </Typography>
            {row.notes ? (
              <Typography component="span" sx={{ color: disabled ? 'action.disabled' : 'secondary.main' }}>
                <Iconify icon="clarity:note-solid" width={16} height={16} />
              </Typography>
            ) : (
              <Typography component="span">
                <Iconify icon="clarity:note-line" width={16} height={16} />
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            component="div"
            sx={{
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              '&:hover': {
                cursor: 'copy',
              },
            }}
            onClick={() => {
              navigator.clipboard.writeText(row.productId);
            }}
          >
              {row.itemId !== -1 ? ` PS${row.productId}` : "Punchout Item"}           
          </Box>
        )}
      </Tooltip>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleClose();
        }}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle
          sx={{
            textAlign: 'center',
          }}
        >
          Item Info - PS{row.productId}
          <CloseIconButton onClick={handleClose}/>
        </DialogTitle>
        <DialogContent>
          <CatalogItem row={row} />
        </DialogContent>
      </Dialog>
    </>
  );
}
